package com.dotdrives.web.pages.forms

import com.dotdrives.model.EmployerMatch
import react.*
import react.dom.html.ReactHTML.button
import react.dom.html.ReactHTML.div
import react.dom.html.ReactHTML.span
import react.dom.html.ReactHTML.label
import react.dom.html.ReactHTML.input
import react.dom.html.ReactHTML.textarea
import react.dom.html.ReactHTML.select
import react.dom.html.ReactHTML.option
import react.dom.html.ReactHTML.p
import web.cssom.ClassName
import web.html.ButtonType
import web.html.InputType
import web.html.button as buttonType
import web.html.text

val FormEmployerEditor = FC<FormTabProps> { props ->
    val matches = props.state.draftEmployerMatches
    fun change(index: Int, next: EmployerMatch) {
        if (props.canWrite) props.controller.setEmployerMatches(matches.mapIndexed { i, match -> if (i == index) next else match })
    }
    p { className = ClassName("forms-field-note"); +"List programs your donors can follow up with. These instructions do not submit a matching request or contact an employer." }
    matches.forEachIndexed { index, match ->
        div {
            key = index.toString().unsafeCast<Key>(); className = ClassName("forms-v2-match-card")
            listOf("Employer" to match.employer, "Email domain (optional)" to match.domain, "Program URL (optional)" to match.url.orEmpty()).forEachIndexed { fieldIndex, (title, current) ->
                label {
                    className = ClassName("forms-v2-field"); span { +title }
                    input {
                        type = InputType.text; value = current; ariaLabel = "$title ${index + 1}"; disabled = !props.canWrite
                        onChange = { event ->
                            val value = event.currentTarget.value
                            change(index, when (fieldIndex) { 0 -> match.copy(employer = value); 1 -> match.copy(domain = value); else -> match.copy(url = value.takeIf(String::isNotBlank)) })
                        }
                    }
                }
            }
            label {
                className = ClassName("forms-v2-field"); span { +"Instructions for donors" }
                textarea { rows = 3; value = match.instructions; ariaLabel = "Matching instructions ${index + 1}"; disabled = !props.canWrite; onChange = { change(index, match.copy(instructions = it.currentTarget.value)) } }
            }
            button {
                type = ButtonType.buttonType; className = ClassName("forms-v2-remove"); disabled = !props.canWrite
                ariaLabel = "Remove employer ${index + 1}"; onClick = { if (props.canWrite) props.controller.setEmployerMatches(matches.filterIndexed { i, _ -> i != index }) }; +"Remove program"
            }
        }
    }
    button {
        type = ButtonType.buttonType; className = ClassName("forms-v2-add"); disabled = !props.canWrite || matches.size >= 30
        onClick = { if (props.canWrite && matches.size < 30) props.controller.setEmployerMatches(matches + EmployerMatch("")) }; +"+ Add employer program"
    }
}
